module.exports = __webpack_public_path__ + "img/logo@3x.191e87f6.png";